import type { HealthcheckResponse, PinnacleHealthResponse, StatusHealthResponse } from './types'
import type { UseQueryResult } from '@tanstack/react-query'

import { useQuery } from '@tanstack/react-query'

import $api from '../../API'

export function useNomi835Status(): UseQueryResult<HealthcheckResponse> {
  return useQuery<HealthcheckResponse>({
    queryKey: ['healthcheck', 'nomi835', 'status'],
    async queryFn({ signal }) {
      const response = await $api.get<HealthcheckResponse>('/healthcheck/nomi835/status', {
        method: 'GET',
        signal
      })
      return response.data
    },
    refetchInterval: 60_000
  })
}

export function useNomiStatusHealth(): UseQueryResult<StatusHealthResponse> {
  return useQuery<StatusHealthResponse>({
    queryKey: ['healthcheck', 'nomi-status', 'status'],
    async queryFn({ signal }) {
      const res = await $api.get<StatusHealthResponse>('/healthcheck/nomi-status-files/status', {
        method: 'GET',
        signal
      })
      return res.data
    },
    refetchInterval: 60_000
  })
}

export function usePinnacleHealth(): UseQueryResult<PinnacleHealthResponse> {
  return useQuery<PinnacleHealthResponse>({
    queryKey: ['healthcheck', 'pinnacle', 'status'],
    async queryFn({ signal }) {
      const res = await $api.get<PinnacleHealthResponse>('/healthcheck/pinnacle/status', {
        method: 'GET',
        signal
      })
      return res.data
    },
    refetchInterval: 60_000
  })
}
